// src/routes/AppRoutes.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Services from "../pages/Services";
import CancelRefund from "../pages/CancelRefund";
import Processing from "../pages/Processing";
import Success from "../pages/Success";
import ThankYou from "../pages/ThankYou";
import Complaint from "../pages/Complaint";
import Feedback from "../pages/Feedback";
import Claim from "../pages/Claim";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/"              element={<Home />} />
      <Route path="/services"      element={<Services />} />
      <Route path="/cancel-refund" element={<CancelRefund />} />
      <Route path="/processing"    element={<Processing />} />
      <Route path="/success"       element={<Success />} />
      <Route path="/thankyou"      element={<ThankYou />} />
      <Route path="/complaint"     element={<Complaint />} />
      <Route path="/feedback"      element={<Feedback />} />
      <Route path="/Claim"      element={<Claim />} />


    </Routes>
  );
};

export default AppRoutes;